import { render, staticRenderFns } from "./SupplierCupom.vue?vue&type=template&id=0861bad4"
import script from "./SupplierCupom.vue?vue&type=script&lang=js"
export * from "./SupplierCupom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports